(function () {
  var header = document.querySelector("[data-mana-header]");
  if (!header) return;

  var nav = header.querySelector("[data-mana-nav]");
  var menuBtn = header.querySelector("[data-mana-menu]");
  var megaTrigger = header.querySelector("[data-mega-trigger]");
  var megaPanel = header.querySelector("[data-mega-panel]");
  if (!nav) return;

  /* Match local: index --nav-i on children for staggered open */
  Array.prototype.forEach.call(nav.children, function (el, i) {
    el.style.setProperty("--nav-i", String(i));
  });

  /* Backdrop on body (same as local mega-menu.js) */
  var backdrop = document.querySelector("[data-mana-backdrop]");
  if (!backdrop) {
    backdrop = document.createElement("button");
    backdrop.type = "button";
    backdrop.className = "mana-nav-backdrop";
    backdrop.setAttribute("data-mana-backdrop", "");
    backdrop.setAttribute("aria-label", "Close menu");
    document.body.appendChild(backdrop);
  }

  function setNavTop() {
    var bottom = Math.round(header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty("--nav-top", bottom + "px");
  }

  function setMenuOpen(open) {
    nav.classList.toggle("is-open", open);
    if (menuBtn) menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.classList.toggle("mana-nav-open", open);
    setNavTop();
    if (open) setMega(false);
  }

  function setMega(open) {
    header.classList.toggle("has-mega", open);
    if (megaTrigger) megaTrigger.setAttribute("aria-expanded", open ? "true" : "false");
    if (megaPanel) megaPanel.setAttribute("aria-hidden", open ? "false" : "true");
  }

  if (menuBtn) {
    menuBtn.addEventListener("click", function () {
      setMenuOpen(!nav.classList.contains("is-open"));
    });
  }

  backdrop.addEventListener("click", function () {
    setMenuOpen(false);
  });

  if (megaTrigger && megaPanel) {
    var megaRoot = header.querySelector("[data-mega]");
    var leaveTimer;
    var departments = [];
    var activeDept = "";
    var mainsEl = megaPanel.querySelector("[data-mega-mains]");
    var subsGrid = megaPanel.querySelector("[data-mega-subs-grid]");
    var subsTitle = megaPanel.querySelector("[data-mega-subs-title]");
    var subsAll = megaPanel.querySelector("[data-mega-subs-all]");

    function escapeHtml(str) {
      return String(str || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function deptByHandle(handle) {
      for (var i = 0; i < departments.length; i++) {
        if (departments[i].handle === handle) return departments[i];
      }
      return null;
    }

    function subCard(child) {
      var href = "/collections/" + encodeURIComponent(child.handle || "");
      var img = child.img
        ? '<img src="' + escapeHtml(child.img) + '" alt="" loading="lazy" width="40" height="40">'
        : "";
      var thumbClass = child.img ? "mana-mega__thumb" : "mana-mega__thumb mana-mega__thumb--empty";
      return (
        '<a class="mana-mega__card" href="' +
        href +
        '"><span class="' +
        thumbClass +
        '">' +
        img +
        '</span><span class="mana-mega__name">' +
        escapeHtml(child.title || child.handle) +
        "</span></a>"
      );
    }

    function showDept(handle) {
      if (!handle) return;
      activeDept = handle;
      if (mainsEl) {
        mainsEl.querySelectorAll("[data-mega-dept]").forEach(function (el) {
          var on = el.getAttribute("data-mega-dept") === handle;
          el.classList.toggle("is-active", on);
          if (on) el.setAttribute("aria-current", "true");
          else el.removeAttribute("aria-current");
        });
      }
      var dept = deptByHandle(handle);
      var title = (dept && dept.title) || handle;
      var kids = (dept && dept.children) || [];
      if (subsTitle) subsTitle.textContent = title;
      if (subsAll) {
        subsAll.href = "/collections/" + encodeURIComponent(handle);
        subsAll.textContent = "Shop all " + title;
      }
      if (!subsGrid) return;
      if (!kids.length) {
        subsGrid.innerHTML =
          '<p class="mana-mega__empty">No sub-collections yet. <a href="/collections/' +
          encodeURIComponent(handle) +
          '">Browse ' +
          escapeHtml(title) +
          "</a>.</p>";
        return;
      }
      subsGrid.innerHTML = kids.map(subCard).join("");
    }

    function enrichMainsFromDepartments() {
      if (!mainsEl || !departments.length) return;
      var order = ["crockery", "decor", "bedding", "electronics", "luggage-bags"];
      var html = order
        .map(function (handle, idx) {
          var d = deptByHandle(handle);
          if (!d) return "";
          var img = d.img
            ? '<img src="' + escapeHtml(d.img) + '" alt="" loading="lazy" width="40" height="40">'
            : "";
          var thumbClass = d.img ? "mana-mega__thumb" : "mana-mega__thumb mana-mega__thumb--empty";
          var active = (!activeDept && idx === 0) || activeDept === handle;
          return (
            '<a class="mana-mega__dept' +
            (active ? " is-active" : "") +
            '" href="/collections/' +
            encodeURIComponent(handle) +
            '" role="listitem" data-mega-dept="' +
            escapeHtml(handle) +
            '"' +
            (active ? ' aria-current="true"' : "") +
            '><span class="' +
            thumbClass +
            '">' +
            img +
            '</span><span class="mana-mega__name">' +
            escapeHtml(d.title || handle) +
            '</span><span class="mana-mega__chev" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></span></a>'
          );
        })
        .join("");
      if (html) mainsEl.innerHTML = html;
    }

    function bindDeptHover() {
      if (!mainsEl) return;
      mainsEl.querySelectorAll("[data-mega-dept]").forEach(function (el) {
        el.addEventListener("mouseenter", function () {
          showDept(el.getAttribute("data-mega-dept"));
        });
        el.addEventListener("focus", function () {
          showDept(el.getAttribute("data-mega-dept"));
        });
      });
    }

    async function loadDepartments() {
      var url = megaPanel.getAttribute("data-departments-url");
      if (!url) return;
      try {
        var res = await fetch(url);
        if (!res.ok) return;
        var data = await res.json();
        if (!Array.isArray(data) || !data.length) return;
        departments = data;
        enrichMainsFromDepartments();
        bindDeptHover();
        showDept(activeDept || departments[0].handle);
      } catch (_) {}
    }

    function openMega() {
      if (window.matchMedia("(max-width: 980px)").matches) return;
      clearTimeout(leaveTimer);
      setMega(true);
      if (!departments.length) loadDepartments();
      else if (activeDept) showDept(activeDept);
    }
    function closeMega() {
      leaveTimer = setTimeout(function () {
        setMega(false);
      }, 120);
    }
    if (megaRoot) {
      megaRoot.addEventListener("mouseenter", openMega);
      megaRoot.addEventListener("mouseleave", closeMega);
    }
    megaPanel.addEventListener("mouseenter", openMega);
    megaPanel.addEventListener("mouseleave", closeMega);
    megaTrigger.addEventListener("click", function (e) {
      if (window.matchMedia("(max-width: 980px)").matches) {
        /* On mobile Categories is a normal link into collections */
        return;
      }
      e.preventDefault();
      setMega(!header.classList.contains("has-mega"));
      if (header.classList.contains("has-mega") && !departments.length) loadDepartments();
    });
    bindDeptHover();
    /* Prefetch so first hover is instant */
    loadDepartments();
  }

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    setMenuOpen(false);
    setMega(false);
  });

  window.addEventListener("resize", function () {
    setNavTop();
    if (window.matchMedia("(min-width: 981px)").matches) setMenuOpen(false);
  });
  window.addEventListener(
    "scroll",
    function () {
      if (nav.classList.contains("is-open")) setNavTop();
    },
    { passive: true }
  );

  setNavTop();

  /* Sheets + search - local chrome parity on every page */
  function readJson(key, fallback) {
    try {
      return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback));
    } catch (_) {
      return fallback;
    }
  }

  function money(n) {
    return "Rs." + Number(n || 0).toLocaleString("en-PK");
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function productMap() {
    return readJson("mana_products", {});
  }

  function findProduct(id) {
    var map = productMap();
    return map[id] || null;
  }

  function closeSheets() {
    document.querySelectorAll(".sheet").forEach(function (s) {
      s.hidden = true;
    });
  }

  function renderWishFallback() {
    var box = document.querySelector('[data-list="wish"]');
    var actions = document.querySelector("[data-wish-actions]");
    if (!box) return;
    var wish = readJson("mana_wish", []);
    var rows = wish.map(findProduct).filter(Boolean);
    if (!rows.length) {
      box.innerHTML = "<p>No saved pieces yet.</p>";
      if (actions) actions.innerHTML = "";
      return;
    }
    box.innerHTML = rows
      .map(function (p) {
        return (
          '<div class="sheet-row"><img src="' +
          (p.img || "") +
          '" alt=""><div><strong>' +
          escapeHtml(p.title) +
          "</strong><span>" +
          escapeHtml(p.price) +
          '</span></div><button type="button" data-remove-wish="' +
          escapeHtml(p.id) +
          '">Remove</button></div>'
        );
      })
      .join("");
    var names = rows.map(function (p) { return p.title; }).join(", ");
    var msg = encodeURIComponent("I would like to enquire about my favorites: " + names + ".");
    if (actions) {
      actions.innerHTML =
        '<a class="btn btn-gold" href="https://wa.me/923114711112?text=' +
        msg +
        '">Enquire on WhatsApp</a>';
    }
  }

  function renderCartFallback() {
    var box = document.querySelector('[data-list="cart"]');
    var foot = document.querySelector("[data-cart-foot]");
    if (!box) return;
    var cart = readJson("mana_cart", []);
    var rows = cart
      .map(function (item) {
        return { item: item, p: findProduct(item.id) };
      })
      .filter(function (r) {
        return r.p;
      });
    if (!rows.length) {
      box.innerHTML = "<p>Your cart is empty.</p>";
      if (foot) foot.innerHTML = "";
      return;
    }
    box.innerHTML = rows
      .map(function (r) {
        return (
          '<div class="sheet-row"><img src="' +
          (r.p.img || "") +
          '" alt=""><div><strong>' +
          escapeHtml(r.p.title) +
          "</strong><span>" +
          escapeHtml(r.p.price) +
          " × " +
          r.item.qty +
          '</span></div><button type="button" data-remove-cart="' +
          escapeHtml(r.p.id) +
          '">Remove</button></div>'
        );
      })
      .join("");
    var total = rows.reduce(function (n, r) {
      return n + (Number(r.p.amount) || 0) * r.item.qty;
    }, 0);
    var lines = rows
      .map(function (r) {
        return r.p.title + " × " + r.item.qty;
      })
      .join(", ");
    var wa = "I would like to order: " + lines + ". Total " + money(total) + ".";
    if (foot) {
      foot.innerHTML =
        typeof window.manaCartFootHTML === "function"
          ? window.manaCartFootHTML("Total " + money(total), wa)
          : "<div>Total " +
            money(total) +
            '</div><div class="sheet__actions"><button type="button" class="btn btn-dark" data-checkout>Checkout</button><a class="btn btn-gold" href="https://wa.me/923114711112?text=' +
            encodeURIComponent(wa) +
            '">Order on WhatsApp</a></div>';
    }
  }

  function renderCompareFallback() {
    var box = document.querySelector('[data-list="compare"]');
    if (!box) return;
    var compare = readJson("mana_compare", []);
    var rows = compare.map(findProduct).filter(Boolean);
    if (!rows.length) {
      box.innerHTML = "<p>Add products to compare.</p>";
      return;
    }
    box.innerHTML =
      '<div class="compare-bar"><p>' +
      rows.length +
      ' product(s) ready to compare.</p><a class="btn btn-gold" href="/collections/all">Browse shop</a></div><div class="compare-grid" style="--cols:' +
      rows.length +
      '">' +
      rows
        .map(function (p) {
          return (
            '<article class="compare-card"><div class="cmp-media"><img class="is-active" src="' +
            (p.img || "") +
            '" alt=""></div><div class="compare-card__info"><strong>' +
            escapeHtml(p.title) +
            '</strong><div class="price">' +
            escapeHtml(p.price) +
            '</div></div><div class="compare-card__actions"><a class="btn btn-dark" href="/products/' +
            encodeURIComponent(p.id) +
            '">View</a><button type="button" class="btn btn-gold" data-remove-compare="' +
            escapeHtml(p.id) +
            '">Remove</button></div></article>'
          );
        })
        .join("") +
      "</div>";
  }

  function openSheet(name) {
    var sheet = document.getElementById("sheet-" + name);
    if (!sheet) return;
    setMenuOpen(false);
    closeSheets();
    if (name === "wish") {
      if (typeof window.renderWish === "function") window.renderWish();
      else renderWishFallback();
    } else if (name === "cart") {
      if (typeof window.renderCart === "function") window.renderCart();
      else renderCartFallback();
    } else if (name === "compare") {
      if (typeof window.renderCompare === "function") window.renderCompare();
      else renderCompareFallback();
    }
    sheet.hidden = false;
  }

  document.querySelectorAll(".mana-icons [data-open]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openSheet(btn.getAttribute("data-open"));
    });
  });

  document.querySelectorAll(".sheet [data-close]").forEach(function (btn) {
    btn.addEventListener("click", closeSheets);
  });
  document.querySelectorAll(".sheet").forEach(function (sheet) {
    sheet.addEventListener("click", function (e) {
      if (e.target === sheet) closeSheets();
    });
  });

  /* Sheet list actions when page scripts are not present */
  document.addEventListener("click", function (e) {
    var wishId = e.target.closest && e.target.closest("[data-remove-wish]");
    if (wishId && typeof window.renderWish !== "function") {
      var wid = wishId.getAttribute("data-remove-wish");
      var wish = readJson("mana_wish", []).filter(function (id) {
        return id !== wid;
      });
      localStorage.setItem("mana_wish", JSON.stringify(wish));
      renderWishFallback();
      syncIconCounts();
    }
    var cartId = e.target.closest && e.target.closest("[data-remove-cart]");
    if (cartId && typeof window.renderCart !== "function") {
      var cid = cartId.getAttribute("data-remove-cart");
      var cart = readJson("mana_cart", []).filter(function (i) {
        return i.id !== cid;
      });
      localStorage.setItem("mana_cart", JSON.stringify(cart));
      renderCartFallback();
      syncIconCounts();
    }
    var cmpId = e.target.closest && e.target.closest("[data-remove-compare]");
    if (cmpId && typeof window.renderCompare !== "function") {
      var mid = cmpId.getAttribute("data-remove-compare");
      var compare = readJson("mana_compare", []).filter(function (id) {
        return id !== mid;
      });
      localStorage.setItem("mana_compare", JSON.stringify(compare));
      renderCompareFallback();
      syncIconCounts();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeSheets();
      var searchRoot = document.getElementById("search");
      if (searchRoot) searchRoot.hidden = true;
    }
  });

  /* Live search (if page script did not bind) */
  var searchRoot = document.getElementById("search");
  var searchInput = document.getElementById("search-input");
  var searchBox = document.querySelector("[data-search-results]");
  var searchTimer = 0;

  function shopImage(src, width) {
    if (!src) return "";
    width = width || 160;
    if (src.indexOf("cdn.shopify.com") === -1) return src;
    if (/[?&]width=/.test(src)) return src.replace(/([?&]width=)\d+/g, "$1" + width);
    return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=" + width;
  }

  function searchRow(item) {
    return (
      '<a class="search-row" href="' +
      item.url +
      '"><img src="' +
      item.img +
      '" alt=""><div><strong>' +
      escapeHtml(item.title) +
      "</strong><small>" +
      escapeHtml(item.price || item.type) +
      "</small></div><em>" +
      escapeHtml(item.type) +
      "</em></a>"
    );
  }

  async function liveSearch(q) {
    var path =
      "/search/suggest.json?q=" +
      encodeURIComponent(q) +
      "&resources[type]=product,collection&resources[limit]=8";
    var res = await fetch(path);
    if (!res.ok) res = await fetch("https://mannacrockery.pk" + path);
    var data = await res.json();
    var products = ((((data.resources || {}).results || {}).products) || []).map(function (p) {
      var handle = p.handle || String(p.url || "").split("/").pop();
      var price = Number(p.price);
      var label = "";
      if (Number.isFinite(price)) {
        var value = price > 9999 ? Math.round(price / 100) : price;
        label = "Rs." + value.toLocaleString("en-PK");
      }
      return {
        title: p.title,
        url: "/products/" + encodeURIComponent(handle),
        img: shopImage(p.image || ""),
        price: label,
        type: "Product"
      };
    });
    var collections = ((((data.resources || {}).results || {}).collections) || []).map(function (c) {
      return {
        title: c.title,
        url: "/collections/" + encodeURIComponent(c.handle || ""),
        img: shopImage((c.featured_image && c.featured_image.url) || c.image || ""),
        price: "",
        type: "Collection"
      };
    });
    return products.concat(collections);
  }

  var searchSuggest = document.querySelector("[data-search-suggest]");
  var searchClear = document.querySelector("[data-search-clear]");
  var searchBound = false;

  function setSearchIdle(idle) {
    if (searchSuggest) searchSuggest.hidden = !idle;
    if (searchClear) searchClear.hidden = idle;
  }

  function runLiveSearch(q) {
    if (!searchBox) return;
    clearTimeout(searchTimer);
    if (!q) {
      searchBox.innerHTML = "";
      setSearchIdle(true);
      return;
    }
    setSearchIdle(false);
    searchBox.innerHTML = '<p class="search-empty">Searching…</p>';
    searchTimer = setTimeout(async function () {
      try {
        var rows = await liveSearch(q);
        searchBox.innerHTML = rows.length
          ? rows.map(searchRow).join("")
          : '<p class="search-empty"><strong>No matches</strong>Nothing found for “' +
            escapeHtml(q) +
            '”. Try dinner set, tea set, or lamp.</p>';
      } catch (_) {
        searchBox.innerHTML =
          '<p class="search-empty"><strong>Search unavailable</strong>Please try again in a moment.</p>';
      }
    }, 220);
  }

  var openSearchBtn = document.querySelector("[data-open-search]");
  if (openSearchBtn && searchRoot) {
    openSearchBtn.addEventListener("click", function () {
      searchRoot.hidden = false;
      setSearchIdle(!(searchInput && searchInput.value.trim()));
      window.setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 40);
    });
  }
  var closeSearchBtn = document.querySelector("[data-close-search]");
  if (closeSearchBtn && searchRoot) {
    closeSearchBtn.addEventListener("click", function () {
      searchRoot.hidden = true;
    });
  }
  if (searchRoot) {
    searchRoot.addEventListener("click", function (e) {
      if (e.target === searchRoot) searchRoot.hidden = true;
    });
  }
  if (searchClear && searchInput) {
    searchClear.addEventListener("click", function () {
      searchInput.value = "";
      searchBox.innerHTML = "";
      setSearchIdle(true);
      searchInput.focus();
    });
  }
  document.querySelectorAll("[data-search-chip]").forEach(function (chip) {
    chip.addEventListener("click", function () {
      if (!searchInput) return;
      var q = chip.getAttribute("data-search-chip") || chip.textContent || "";
      searchInput.value = q;
      runLiveSearch(q.trim());
      searchInput.focus();
    });
  });
  if (searchInput && searchBox && !window.__manaSearchBound) {
    window.__manaSearchBound = true;
    searchBound = true;
    searchInput.addEventListener("input", function () {
      runLiveSearch(searchInput.value.trim());
    });
  }
  if (!searchBound) {
    /* Page script owns input - still keep chips/clear/suggest in sync */
    if (searchInput) {
      searchInput.addEventListener("input", function () {
        var q = searchInput.value.trim();
        setSearchIdle(!q);
        if (searchClear) searchClear.hidden = !q;
      });
    }
  }

  function syncIconCounts() {
    var wish = readJson("mana_wish", []);
    var compare = readJson("mana_compare", []);
    var cart = readJson("mana_cart", []);
    var cartQty = cart.reduce(function (n, i) {
      return n + (Number(i.qty) || 0);
    }, 0);
    var map = { wish: wish.length, compare: compare.length, cart: cartQty };
    document.querySelectorAll(".mana-icons [data-count]").forEach(function (el) {
      var n = map[el.getAttribute("data-count")] || 0;
      el.textContent = n || "";
      el.setAttribute("data-empty", n ? "false" : "true");
    });
    var wishBtn = document.querySelector('.mana-icons [data-open="wish"]');
    if (wishBtn) wishBtn.classList.toggle("is-visible", wish.length > 0);
  }
  syncIconCounts();
  window.addEventListener("storage", syncIconCounts);
  window.manaSyncIconCounts = syncIconCounts;
  window.manaOpenSheet = openSheet;
})();
